/* ===========================================================================
   EUPHORIA · BOOST                                    assets/euphoria-boost.js
   1. Live viewer count + units-sold figure on the product page
   2. Swipeable product images on category / search cards
   3. Main-menu links that stay in the language the shopper is browsing
   No dependencies. Each part no-ops safely when its markup or setting is off.
   Config comes from  <script type="application/json" id="eu-boost-cfg">
   written by snippets/euphoria-boost.liquid.
   =========================================================================== */
(function () {
  'use strict';

  var CFG = {};
  try {
    var el = document.getElementById('eu-boost-cfg');
    if (el) { CFG = JSON.parse(el.textContent) || {}; }
  } catch (e) { CFG = {}; }

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }
  function hash(str) {
    var h = 2166136261;
    for (var i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return h >>> 0;
  }
  /* Latin digits + thousands separators, so the figure matches the price format
     rather than switching to Arabic-Indic numerals on the Arabic storefront. */
  function group(n) {
    var v = Number(n);
    if (!isFinite(v)) { return String(n); }
    try { return v.toLocaleString('en-US'); } catch (e) { return String(v); }
  }
  function clamp(n, lo, hi) { return n < lo ? lo : (n > hi ? hi : n); }

  /* =========================================================================
     1 · LIVE SOCIAL PROOF
     The viewer figure is seeded from the product id + this visitor's session,
     so it holds still across refreshes — a counter that re-rolls on every page
     view is exactly what makes these read as fake. It then drifts a point or
     two on a slow clock so the page feels live while someone reads it.
     The units-sold figure is real data; it only gets thousands separators.
     ========================================================================= */
  function socialProof() {
    var sold = document.querySelectorAll('[data-eu-sold]');
    for (var s = 0; s < sold.length; s++) {
      sold[s].textContent = group(sold[s].getAttribute('data-eu-sold'));
    }

    var nodes = document.querySelectorAll('[data-eu-watch]');
    if (!nodes.length) { return; }

    var seed = '1';
    try {
      seed = sessionStorage.getItem('eu-seed');
      if (!seed) {
        seed = String(Math.floor(Math.random() * 1e9));
        sessionStorage.setItem('eu-seed', seed);
      }
    } catch (e) { /* private mode — fall back to a fixed seed */ }

    var every = (parseInt(CFG.watch_refresh, 10) || 25) * 1000;

    function paint() {
      var bucket = Math.floor(Date.now() / every);
      for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        var out = node.querySelector('[data-eu-n]');
        if (!out) { continue; }
        var lo = parseInt(node.getAttribute('data-eu-min'), 10) || 12;
        var hi = parseInt(node.getAttribute('data-eu-max'), 10) || 40;
        if (hi < lo) { var t = lo; lo = hi; hi = t; }
        var key = node.getAttribute('data-eu-watch') + '|' + seed;
        var base = lo + (hash(key) % (hi - lo + 1));
        var drift = (hash(key + '|' + bucket) % 5) - 2;
        var str = group(clamp(base + drift, lo, hi));
        if (out.textContent !== str) { out.textContent = str; }
        out.style.opacity = '1';
      }
    }

    paint();
    setInterval(paint, every);
  }

  /* =========================================================================
     2 · CATEGORY CARD IMAGE SLIDER
     Swipe on touch, arrows on hover, tappable dots — without opening the
     product. Images are pulled per card from /products/<handle>.js the first
     time the card comes near the viewport, two requests at a time, so a long
     category page costs nothing until it is actually scrolled.
     ========================================================================= */
  var CHEVRON = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' +
                '<path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="2" ' +
                'stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function cardSliders() {
    if (!CFG.cards) { return; }
    var roots = document.querySelectorAll(CFG.cards_in || '#product-grid');
    if (!roots.length) { return; }

    var MAX = parseInt(CFG.cards_max, 10) || 5;
    var cards = [];
    for (var r = 0; r < roots.length; r++) {
      var found = roots[r].querySelectorAll('.card-product');
      for (var c = 0; c < found.length; c++) { cards.push(found[c]); }
    }
    if (!cards.length) { return; }

    var queue = [];
    var running = 0;

    function pump() {
      while (running < 2 && queue.length) {
        running++;
        load(queue.shift());
      }
    }
    function done() { running--; pump(); }

    function handleOf(card) {
      var a = card.querySelector('a[href*="/products/"]');
      if (!a) { return null; }
      var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      return m ? m[1] : null;
    }

    function sized(src, px) {
      if (!src) { return null; }
      return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + px;
    }

    function load(card) {
      var handle = handleOf(card);
      var img = card.querySelector('picture img') || card.querySelector('img');
      if (!handle || !img || card.querySelector('.splide__slide')) { return done(); }

      var mount = mountOf(img, card);
      if (!mount) { return done(); }

      var dpr = window.devicePixelRatio || 1;
      var px = Math.min(1200, Math.max(400, Math.ceil((mount.offsetWidth * dpr) / 100) * 100));

      fetch(ROOT.replace(/\/$/, '') + '/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (p) {
          if (!p) { return; }
          var urls = [];
          var seen = {};
          var list = (p.media && p.media.length) ? p.media : null;
          if (list) {
            for (var i = 0; i < list.length && urls.length < MAX; i++) {
              if (list[i].media_type !== 'image') { continue; }
              var src = list[i].preview_image && list[i].preview_image.src;
              if (!src || seen[src]) { continue; }
              seen[src] = 1;
              urls.push(sized(src, px));
            }
          } else if (p.images) {
            for (var j = 0; j < p.images.length && urls.length < MAX; j++) {
              if (seen[p.images[j]]) { continue; }
              seen[p.images[j]] = 1;
              urls.push(sized(p.images[j], px));
            }
          }
          /* Slide 1 reuses the file the browser already fetched for the card,
             so turning the slider on costs no extra image bytes up front. */
          if (urls.length > 1) {
            if (img.currentSrc) { urls[0] = img.currentSrc; }
            build(card, mount, img, urls);
          }
        })
        .catch(function () { /* offline or 404 — the card keeps its static image */ })
        .then(done, done);
    }

    /* First ancestor of the image that is a real box we can overlay.
       <picture> is skipped: it is inline, so it makes a poor containing block. */
    function mountOf(img, card) {
      var el = img.parentNode;
      while (el && el !== card && el.nodeType === 1) {
        if (el.tagName !== 'PICTURE' && el.tagName !== 'SOURCE' &&
            el.offsetHeight > 40 && el.offsetWidth > 40) {
          var cs = getComputedStyle(el);
          if (cs.display !== 'inline') {
            if (cs.position === 'static') { el.style.position = 'relative'; }
            return el;
          }
        }
        el = el.parentNode;
      }
      return null;
    }

    function build(card, mount, img, urls) {
      var fit = getComputedStyle(img);
      var wrap = document.createElement('div');
      wrap.className = 'eu-cs';

      var track = document.createElement('div');
      track.className = 'eu-cs__track';
      urls.forEach(function (src, i) {
        var slide = document.createElement('div');
        slide.className = 'eu-cs__slide';
        var im = document.createElement('img');
        im.src = src;
        im.alt = '';
        im.setAttribute('aria-hidden', 'true');
        im.loading = i === 0 ? 'eager' : 'lazy';
        im.decoding = 'async';
        im.style.objectFit = fit.objectFit || 'cover';
        im.style.objectPosition = fit.objectPosition || '50% 50%';
        slide.appendChild(im);
        track.appendChild(slide);
      });
      wrap.appendChild(track);

      var dots = null;
      if (CFG.cards_dots !== false) {
        dots = document.createElement('div');
        dots.className = 'eu-cs__dots';
        urls.forEach(function (u, i) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'eu-cs__dot' + (i === 0 ? ' is-on' : '');
          d.setAttribute('aria-label', String(i + 1));
          d.addEventListener('click', function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            go(i);
          });
          dots.appendChild(d);
        });
        wrap.appendChild(dots);
      }

      var prev = null;
      var next = null;
      if (CFG.cards_arrows !== false) {
        prev = arrow('prev');
        next = arrow('next');
        wrap.appendChild(prev);
        wrap.appendChild(next);
      }
      function arrow(dir) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'eu-cs__nav eu-cs__nav--' + dir;
        b.innerHTML = CHEVRON;
        b.setAttribute('aria-label', dir);
        b.addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          go(index() + (dir === 'next' ? 1 : -1));
        });
        return b;
      }

      /* RTL note: scrollLeft runs 0 → negative on right-to-left pages in every
         current browser, so read it through Math.abs and write it signed. */
      var rtl = getComputedStyle(track).direction === 'rtl';
      function width() { return track.clientWidth || 1; }
      function index() { return Math.round(Math.abs(track.scrollLeft) / width()); }
      function go(i) {
        i = clamp(i, 0, urls.length - 1);
        var left = i * width() * (rtl ? -1 : 1);
        if (track.scrollTo) { track.scrollTo({ left: left, behavior: 'smooth' }); }
        else { track.scrollLeft = left; }
      }

      var moved = 0;
      function sync() {
        var i = index();
        if (dots) {
          for (var d = 0; d < dots.children.length; d++) {
            dots.children[d].classList.toggle('is-on', d === i);
          }
        }
        if (prev) { prev.disabled = i <= 0; }
        if (next) { next.disabled = i >= urls.length - 1; }
      }
      track.addEventListener('scroll', function () {
        moved = Date.now();
        sync();
      }, { passive: true });

      /* A horizontal drag inside the card must not count as a click on it. */
      var link = card.querySelector('a[href*="/products/"]');
      if (link) {
        link.addEventListener('click', function (ev) {
          if (Date.now() - moved < 320) {
            ev.preventDefault();
            ev.stopPropagation();
          }
        }, true);
      }

      mount.appendChild(wrap);
      /* The card carries a transparent click overlay at z-index 10. Without
         lifting the media box above it, every swipe landed on that overlay and
         the slider never moved. Quick view (z-20) and the labels stay on top. */
      mount.style.zIndex = '11';
      card.classList.add('eu-cs-on');
      sync();
    }

    if (!('IntersectionObserver' in window)) {
      cards.slice(0, 8).forEach(function (c) { queue.push(c); });
      pump();
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) { return; }
        io.unobserve(entry.target);
        queue.push(entry.target);
        pump();
      });
    }, { rootMargin: '250px 0px' });
    cards.forEach(function (c) { io.observe(c); });
  }

  /* =========================================================================
     3 · KEEP MENU LINKS IN THE CURRENT LANGUAGE
     The main menu is saved with hard-coded /en/ URLs, so every nav click threw
     an Arabic shopper into English and made the language switch pointless.
     This rewrites those hrefs to the locale the shopper is actually browsing.
     The permanent fix is to re-point the menu items in Navigation.
     ========================================================================= */
  function localeLinks() {
    if (!CFG.fix_locale_links) { return; }
    var base = ROOT.replace(/\/$/, '');
    var links = document.querySelectorAll(
      '.eh-menu a[href^="/en/"], .eh-sub a[href^="/en/"], .eh-drawer a[href^="/en/"], ' +
      '.eh-bar a[href^="/en/"], .footer a[href^="/en/"], .euf-footer a[href^="/en/"]'
    );
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href');
      var bare = href.replace(/^\/en(?=\/|$)/, '') || '/';
      var next = base + bare;
      if (next !== href) { links[i].setAttribute('href', next); }
    }
  }

  /* =========================================================================
     4 · PLACE THE SOCIAL-PROOF ROW
     The row is authored once in snippets/euphoria-boost.liquid and cloned in
     here, so every product template picks it up from one set of settings.
     It goes directly UNDER THE PRICE — the shopper reads title, price, then
     this line — and falls back to its old spot above Add to cart only if the
     price block is not on the page at all.
     This runs the moment the deferred script executes: the document is parsed
     and the theme's own block placer has already run, so the row lands before
     first paint and nothing jumps.
     ========================================================================= */
  function placeLiveRow() {
    var tpl = document.getElementById('eu-live-tpl');
    if (!tpl || !tpl.content || !tpl.content.firstElementChild) { return; }
    if (document.querySelector('.eu-live')) { return; }

    function fixed(el) {
      var n = el;
      while (n && n.nodeType === 1) {
        if (getComputedStyle(n).position === 'fixed') { return true; }
        n = n.parentNode;
      }
      return false;
    }

    /* --- preferred: immediately after the price in the real buy box --------
       The page also carries a hidden quick-view copy of the product info and a
       sticky bar; both have a price, and neither is where this belongs. */
    var infos = document.querySelectorAll('[id^="ProductInfo-"]');
    for (var p = 0; p < infos.length; p++) {
      var info = infos[p];
      if (info.id.indexOf('quick-view') > -1) { continue; }
      var price = info.querySelector('.x-block-price');
      if (!price || fixed(price)) { continue; }

      /* Sit at the same level as the title and the price, not inside the price
         box — the theme lays those out as the column's own children. */
      var slot = price;
      var title = info.querySelector('.x-block-product-title');
      if (title && title.parentNode && title.parentNode !== slot.parentNode) {
        while (slot.parentNode && slot.parentNode !== title.parentNode && slot.parentNode !== info) {
          slot = slot.parentNode;
        }
      }
      if (!slot.parentNode) { continue; }
      slot.parentNode.insertBefore(tpl.content.cloneNode(true), slot.nextSibling);
      return;
    }

    /* --- fallback: above Add to cart (where the row used to live) ---------- */
    var buttons = document.querySelectorAll('form[action*="/cart/add"] button[name="add"]');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      /* skip the sticky bar, quick view and any hidden duplicate form */
      if (!btn.offsetParent || fixed(btn)) { continue; }
      var zone = btn.closest('div') || btn;
      if (!zone.parentNode) { continue; }
      zone.parentNode.insertBefore(tpl.content.cloneNode(true), zone);
      return;
    }
  }

  placeLiveRow();

  ready(function () {
    socialProof();
    localeLinks();
    cardSliders();
  });
})();
